<cs-viewer [dataSource]="data"></cs-viewer>
